export enum TransactionReportColumnsEnum {
  REF = 'REF',
  DATE = 'DATE',
  DESCRIPTION = 'DESCRIPTION',
  CARD = 'CARD',
  AMOUNT = 'AMOUNT',
  FEE = 'FEE',
  TOTALSPENT = 'TOTALSPENT',
  CATEGORY = 'CATEGORY',
  AMOUNTCURRENCY = 'AMOUNTCURRENCY',
  FEECURRENCY = 'FEECURRENCY',
  TOTALSPENTCURRENCY = 'TOTALSPENTCURRENCY',
  RECEIPT = 'RECEIPT',
  NOTE = 'NOTE',
}
